import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { Waypoint } from 'src/app/shared/components/scroll';
import { SuggestedPetitionsLazy } from 'src/app/shared/components/suggestedPetitionsLazy';

import { SiblingsNavigation } from './components/SiblingsNavigation';
import { usePageFooter } from './hooks/usePageFooter';

export const PageFooter: React.FC = () => {
	const {
		data: { petitionId },
		actions: { handleSuggestedPetitionsPosition },
	} = usePageFooter();

	return (
		<div className="col-span-full m-4 md:my-12 xl:mx-0">
			<div>
				<SiblingsNavigation className="mb-8 px-2" />
				<Separator />
			</div>
			<Waypoint
				onPositionChange={({ currentPosition }) => handleSuggestedPetitionsPosition(currentPosition === 'below')}
			/>
			<div className="[&*.suggested-petitions]:mx-auto [&*.suggested-petitions]:px-0">
				<SuggestedPetitionsLazy channel="update_footer" sourceLocation="update_footer" petitionSlugOrId={petitionId} />
			</div>
		</div>
	);
};
